class compareDiscount extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const productCard = this.closest('product-card');
        const isInCard = this.parentNode.hasAttribute('data-product-handle');

        if (productCard && (!isInCard)) {
            productCard.appendChild(this);
        } else {
            //console.warn('No .product-card found for compare-discount');
        }
    }

    init() {

    }
}

window.customElements.define('compare-discount', compareDiscount);